import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { realtime } from "../lib/ws";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    localStorage.removeItem("token");
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => setUser(false))
      .finally(() => setReady(true));
  }, []);

  useEffect(() => {
    if (user) realtime.connect();
    else if (user === false) realtime.disconnect();
  }, [user]);

  const login = (data) => {
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.error("[auth] logout falló", e); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
